import axios from "axios"
import moment from "moment"
import { useAuth0 } from "@auth0/auth0-react"
import { useQuery } from "@tanstack/react-query"
import { usePermissionsList } from "./queries/usePermissions"

const formatDateTime = dateTime => moment(dateTime).format("MMM D, YYYY · h:mm A")
const isUTC = time => time.endsWith("Z") || time.includes("+00:00")

const convertTimesToLocal = data =>
	data.map(item => ({
		...item,
		time: isUTC(item.time) ? formatDateTime(item.time) : item.time
	}))

const useFetchNotifications = shouldFetch => {
	const { getAccessTokenSilently, isAuthenticated } = useAuth0()
	const permissionsData = usePermissionsList()
	const canRead = permissionsData?.includes("read:notifications") ?? false

	const query = useQuery({
		queryKey: ["notifications"],
		queryFn: async () => {
			const token = await getAccessTokenSilently({
				authorizationParams: { audience: process.env.REACT_APP_API_IDENTIFIER }
			})
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/notifications`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			return convertTimesToLocal(response.data)
		},
		enabled: isAuthenticated && canRead,
		staleTime: 1000 * 30,
		refetchInterval: shouldFetch ? 1000 * 30 : false,
		refetchOnMount: "always"
	})

	return {
		notificationsData: query.data,
		notificationsStatus: query.isLoading
			? "loading"
			: query.isError
				? "failed"
				: query.data
					? "succeeded"
					: "idle",
		notificationsError: query.error?.message ?? null
	}
}

export default useFetchNotifications
